// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3C_HP","inputWrap":"Table_inputWrap__32bIK","col":"Table_col__28hXK","bmiTooltip":"Table_bmiTooltip__3haZU"};